const Flag = (props) => (
    <img alt={`${props.lang} Language Flag`} src={`/static/images/languageFlags/${props.lang}.svg`} {...props} />
  );
  
export default Flag;
  